import api from './config';

export interface AdminPlace {
  id: number;
  place_id: string;
  title: string;
  url: string | null;
  address: string;
  city: string;
  state: string;
  country_code: string;
  latitude: number | null;
  longitude: number | null;
  category_name: string;
  total_score: number | null;
  reviews_count: number | null;
  permanently_closed: boolean;
  temporarily_closed: boolean;
  brand_id: string;
  brand_name: string;
  image_url: string | null;
  created_at: string;
  updated_at: string;
}

export interface CreatePlaceRequest {
  title: string;
  url?: string;
  address?: string;
  city?: string;
  state?: string;
  country_code?: string;
  latitude?: number;
  longitude?: number;
  category_name?: string;
  brand_id: string;
  place_id?: string;
  permanently_closed?: boolean;
  temporarily_closed?: boolean;
}

export interface UpdatePlaceRequest {
  title?: string;
  url?: string;
  address?: string;
  city?: string;
  state?: string;
  country_code?: string;
  latitude?: number;
  longitude?: number;
  category_name?: string;
  brand_id?: string;
  place_id?: string;
  permanently_closed?: boolean;
  temporarily_closed?: boolean;
}

export interface PlaceFilterOptions {
  cities: string[];
  brands: { brand_id: string; brand_name: string }[];
}

interface PaginatedResponse<T> {
  success: boolean;
  data: T[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export const outletManagementService = {
  async getPlaces(params: {
    page?: number;
    limit?: number;
    search?: string;
    brand_id?: string;
    city?: string;
    status?: string;
  } = {}): Promise<PaginatedResponse<AdminPlace>> {
    const response = await api.get('/admin/places', { params });
    return response.data;
  },

  async createPlace(data: CreatePlaceRequest): Promise<{ success: boolean; data: AdminPlace }> {
    const response = await api.post('/admin/places', data);
    return response.data;
  },

  async updatePlace(id: number, data: UpdatePlaceRequest): Promise<{ success: boolean; data: AdminPlace }> {
    const response = await api.put(`/admin/places/${id}`, data);
    return response.data;
  },

  async deletePlace(id: number): Promise<{ success: boolean; message: string }> {
    const response = await api.delete(`/admin/places/${id}`);
    return response.data;
  },

  async getFilterOptions(): Promise<{ success: boolean; data: PlaceFilterOptions }> {
    const response = await api.get('/admin/places/filter-options');
    return response.data;
  },
};
